import StatusBadge from 'formatters/StatusBadge';
import DateFormatter from 'formatters/DateFormatter';
import DateTimeFormatter from 'formatters/DateTimeFormatter';
import CalendarLink from 'formatters/CalendarLink';
// import DrawingRequest from 'formatters/DrawingRequest';
// import DobViolationResolutionRequest from 'formatters/DobViolationResolutionRequest';
import AcrisRealPropertyMaster from 'formatters/AcrisRealPropertyMaster';
import AcrisParty from 'formatters/AcrisParty';
import AcrisImageLink from 'formatters/AcrisImageLink';
import AcrisDetailLink from 'formatters/AcrisDetailLink';
import AcrisPercentTransfer from 'formatters/AcrisPercentTransfer';
import AcrisLotUnit from 'formatters/AcrisLotUnit';
import ECBInfractionCode from 'formatters/ECBInfractionCode';
import OutboundLink from 'formatters/OutboundLink';
import ResolutionRequest from 'formatters/ResolutionRequest';
import { AEU2Link, AEU20Link } from 'formatters/AEULink';
import WorkAppLink from 'formatters/WorkAppLink';
import WorkAppJobNumberLink from 'formatters/WorkAppJobNumberLink';
import BisBoilerNumLink from 'formatters/BisBoilerNumLink';
import HearingDateTimeFormatter from 'formatters/HearingDateTimeFormatter';
import ViolationImageLink from 'formatters/ViolationImageLink';
import WorkPermitPrintLinks from 'formatters/WorkPermitPrintLinks';
import OutstandingFees from 'formatters/OutstandingFees';
import ApplicantAtFirm from 'formatters/ApplicantAtFirm';
import CurrencyAmount from 'formatters/CurrencyAmount';
import TruncatedText from 'formatters/TruncatedText';
import ElectricalFilingStatusBadge from 'formatters/ElectricalFilingStatusBadge';

//todo: refactor this so that new formatters don't need to be added manually

const formatters = {
	StatusBadge: StatusBadge,
	DateFormatter: DateFormatter,
	DateTimeFormatter: DateTimeFormatter,
	CalendarLink: CalendarLink,
	// DrawingRequest: DrawingRequest,
	// DobViolationResolutionRequest: DobViolationResolutionRequest,
	AEU2Link: AEU2Link,
	AEU20Link: AEU20Link,
	AcrisRealPropertyMaster: AcrisRealPropertyMaster,
	AcrisParty: AcrisParty,
	AcrisImageLink: AcrisImageLink,
	AcrisDetailLink: AcrisDetailLink,
	AcrisPercentTransfer: AcrisPercentTransfer,
	AcrisLotUnit: AcrisLotUnit,
	ECBInfractionCode: ECBInfractionCode,
	OutboundLink: OutboundLink,
	ResolutionRequest: ResolutionRequest,
	OutstandingFees: OutstandingFees,
	ViolationImageLink: ViolationImageLink,
	WorkAppLink: WorkAppLink,
	WorkAppJobNumberLink: WorkAppJobNumberLink,
	BisBoilerNumLink: BisBoilerNumLink,
	HearingDateTimeFormatter: HearingDateTimeFormatter,
	ApplicantAtFirm: ApplicantAtFirm,
	CurrencyAmount: CurrencyAmount,
	TruncatedText: TruncatedText,
	ElectricalFilingStatusBadge: ElectricalFilingStatusBadge,
	WorkPermitPrintLinks: WorkPermitPrintLinks,
};

export default formatters;